import { useEffect } from "react";

// The Google Ads landing page lives in ONE place: the static
// public/landing-google-ads.html, which nginx serves directly. This SPA route
// (/landing-google-ads, without .html) used to render a second, divergent copy
// of that page with claims the business does not make. It now just forwards
// to the static page, keeping the query string so gclid/utm_* attribution
// survives. Changed 2026-10-14.
export default function GoogleAdsLandingPage() {
  useEffect(() => {
    window.location.replace(
      `/landing-google-ads.html${window.location.search}${window.location.hash}`
    );
  }, []);
  return null;
}
